// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"3b4b10f4","239":"e4026cbc","453":"3a85fd98","667":"6a73bb9e","977":"1ed16cf9"}[chunkId] + ".chunk.js";
};